import { Component } from 'components/company-settings';

/** @ngInject */
export default function companySettingsRouter($stateProvider) {
    const baseState = {
        url: '/company-settings',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.company-settings', baseState);
}



// WEBPACK FOOTER //
// ./app/components/company-settings/company-settings.router.js